import React, { useEffect, useState } from "react";

export const SaveIndicator = ({ isSaving }) => {
  const [isSaved, setIsSaved] = useState(false);

  const [initial, setInitial] = useState(true);

  useEffect(() => {
    if (isSaving === undefined) return; // Don't do anything if isSaving is undefined (e.g. when loading
    if (isSaving) {
      setIsSaved(false); // Reset saved state when starting to save
      setInitial(false);
    } else if (!isSaving) {
      setIsSaved(true); // Set saved state when finished saving
      const timer = setTimeout(() => {
        setIsSaved(false); // Reset saved state after 2 seconds
      }, 2000);
      return () => clearTimeout(timer); // Clear timeout when unmounting
    }
  }, [isSaving]);

  return (
    <div className="save-indicator">
      {isSaving ? (
        <>
            <div className="spinner-border me-3" role="status"></div>
            <span>{gettext('Saving...')}</span>
        </>
      ) : (isSaved && !initial) ? (
        <span className="saved-indicator">{gettext('Saved')}</span>
      ) : null}
    </div>
  );
}
